"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapCurrencyItem = void 0;
function wrapCurrencyItem(item) {
    return {
        baseCurrency: item.BaseCurrency,
        relativeCurrency: item.RelativeCurrency,
        rate: item.Rate,
        isValid: item.IsValid,
        actualizedTimeUtc: new Date(item.ActualizedTimeUTC)
    };
}
exports.wrapCurrencyItem = wrapCurrencyItem;
